import { Link } from "react-router-dom";

export const ATLAS_LOGO =
  "/brand/atlasforge-logo.webp";
export const STS_LOGO =
  "/brand/safe-to-spend-365-logo.webp";
export const EMBER_LOGO =
  "/brand/ember360-logo.webp";

export default function Logo({ testId = "atlasforge-logo" }) {
  return (
    <Link
      to="/"
      data-testid={testId}
      className="flex items-center gap-2.5 group"
    >
      <img
        src={ATLAS_LOGO}
        alt="AtlasForge Financial"
        width="72"
        height="72"
        decoding="async"
        fetchPriority="high"
        className="h-14 md:h-16 w-auto object-contain"
      />
      <span className="font-display text-[17px] tracking-tight text-[#0A1128] group-hover:opacity-80 transition">
        AtlasForge<span className="font-medium text-slate-400 ml-1">Financial</span>
      </span>
    </Link>
  );
}
